import React from 'react';

/** Иконка переключения темы. */
export const DefaultThemeIcon = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8072 25C7.95104 25 4 20.9628 4 15.9998C4 11.0372 7.95104 7 12.8072 7C14.0082 7 9.20428 9.04509 9.20428 15.9998C9.20428 22.9545 14.0082 25 12.8072 25Z"
            stroke="#1F1F22"
            strokeWidth="1.5"
        />
        <path
            d="M14.4772 11.458C14.1502 11.7122 14.0911 12.1833 14.3452 12.5104C14.5994 12.8375 15.0706 12.8966 15.3977 12.6424L14.4772 11.458ZM15.4536 19.4003C15.1224 19.1516 14.6522 19.2184 14.4035 19.5496C14.1547 19.8808 14.2215 20.3509 14.5527 20.5997L15.4536 19.4003ZM18 11.75C20.3427 11.75 22.25 13.6571 22.25 15.9999H23.75C23.75 12.8287 21.1711 10.25 18 10.25V11.75ZM22.25 15.9999C22.25 18.3429 20.3427 20.25 18 20.25V21.75C21.1711 21.75 23.75 19.1713 23.75 15.9999H22.25ZM15.3977 12.6424C16.1178 12.0827 17.0201 11.75 18 11.75V10.25C16.6742 10.25 15.4505 10.7017 14.4772 11.458L15.3977 12.6424ZM18 20.25C17.0452 20.25 16.1642 19.9341 15.4536 19.4003L14.5527 20.5997C15.5134 21.3213 16.7083 21.75 18 21.75V20.25Z"
            fill="#1F1F22"
        />
        <path d="M18 5L18 8M18 27L18 24.086" stroke="#1F1F22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M29 16L26 16" stroke="#1F1F22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M25.7781 8.22168L23.9998 10" stroke="#1F1F22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M25.7781 23.7783L24 22.0002" stroke="#1F1F22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
